import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DEFAULT_THEME, LocalStorageKey, TiangongThemeType } from 'common/types';
import { RootState } from './rootReducer';

type ThemeStore = {
  theme: TiangongThemeType;
};
const initalTheme = JSON.parse(localStorage.getItem(LocalStorageKey.TiangongTheme) as string) || DEFAULT_THEME;
const initialState: ThemeStore = {
  theme: initalTheme,
};

const theme = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme(state, { payload }: PayloadAction<TiangongThemeType>) {
      state.theme = payload;
    },
  },
});

export const { setTheme } = theme.actions;
export const selectTheme = (state: RootState) => state.theme;
export default theme.reducer;
